enum REIMBURSEMENT_TYPES {
  SUBMIT_REIMBURSEMENT_ADMISSION = 'SUBMIT_REIMBURSEMENT_ADMISSION',
  GENERATE_REIMBURSEMENT_OTP = 'GENERATE_REIMBURSEMENT_OTP',
  VERIFY_REIMBURSEMENT_OTP = 'VERIFY_REIMBURSEMENT_OTP',
  SET_REIMBURSEMENT_DETAIL = 'SET_REIMBURSEMENT_DETAIL',
  RESET_REIMBURSEMENT = 'RESET_REIMBURSEMENT',
  SHOW_IR_MODAL = 'SHOW_IR_MODAL',
  SUBMIT_REIMBURSEMENT_IR = 'SUBMIT_REIMBURSEMENT_IR',
  SET_OTP_MODAL_VISIBLE = 'SET_OTP_MODAL_VISIBLE',
}
export default REIMBURSEMENT_TYPES;
